<template>
  <table class="table table-bordered" id="assets_table_fund">

    <thead>
      <tr>
        <th>Cryptocurrency</th>
        <th>Ticker</th>
        <th>Share</th>
        <th>Value (BGN)</th>
        <th>Number of coins</th>
        <th>Price (BGN)</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="coin in coins">
        <td>{{ coin.name }}</td>
        <td>{{ coin.ticker }}</td>
        <td class="text-right">{{ coin.shareStr }}%</td>
        <td class="text-right">{{ coin.valueBGNstr }}</td>
        <td class="text-right formatnum" v-bind:style="{ msonumberformat: '0\.000000000000'}">{{ coin.piecesStr }}</td>
        <td class="text-right">{{ coin.priceBGNstr }}</td>
      </tr>
    </tbody>
  </table>
</template>



<script>
export default {
  props: ['coins'],
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/tables/AssetsTable.vue